import ResvDetail from "pages/auth/room/resv/detail";
import Grid from "components/grid";
import { IDayChkInList } from "interface/home";
import { useTranslation } from "react-i18next";
import { MdOutlineRefresh } from "react-icons/md";
import useModalStore from "store/modal";
import { detail, onViewMore, useRefreshResv } from "./handles";
import { useGetResvData } from "./service";
import { ResvResvCancelProvider } from "../room/resv/context";

type IProps = {
  defaultInList: IDayChkInList[];
};

export default function Resvs({ defaultInList }: IProps) {
  const { t } = useTranslation();
  const onSetModal = useModalStore((state) => state.onSetModal);
  const { dayChkInList } = useGetResvData();
  const { onRefresh } = useRefreshResv();

  const theads = [
    ...prevTheads,
    {
      langNm: "grid_detail",
      type: "detail",
      field: "detail",
      width: 80,
      styles: "",
      click: (props: any) => {
        // 상세
        detail(props);

        onSetModal({
          isOpen: true,
          title: t("md_ttl_resv_detail_cmm"),
          styles: "w-full",
          inner: (
            <ResvResvCancelProvider>
              <ResvDetail />
            </ResvResvCancelProvider>
          ),
        });
      },
    },
  ];
  return (
    <>
      <div className="mt-6">
        <h4 className="p-1 my-1 font-bold flex justify-between items-center border-b-1">
          <span>{t("sub_ttl_2_home")}</span>
          <div className="flex items-end gap-3">
            <button
              className="cursor-pointer bg-navy-400 px-2 rounded-sm"
              onClick={onRefresh}
            >
              <MdOutlineRefresh size={20} color="white" />
            </button>
            <button className="text-red-600 font-borld" onClick={onViewMore}>
              [ 더보기 ]
            </button>
          </div>
        </h4>
        <Grid
          theads={theads}
          rowData={dayChkInList.length === 0 ? defaultInList : dayChkInList}
          pagination={false}
          pageNav={null}
          domLayout="autoHeight"
          alpineHeight={"auto"}
        />
      </div>
    </>
  );
}

const prevTheads = [
  {
    langNm: "grid_no",
    type: "id",
    field: "No",
    width: 100,
  },
  {
    langNm: "grid_cst_nm",
    type: "string",
    field: "resvCstnm",
  },
  {
    langNm: "grid_cst_phone",
    type: "phone",
    field: "resvCstMblNo",
  },
  {
    langNm: "grid_rmpd_nm",
    type: "string",
    field: "rmNm",
  },
  {
    langNm: "grid_resv_s_d_dt",
    type: "string",
    field: "resvDt",
  },
  {
    langNm: "grid_resv_day_ct",
    type: "number",
    field: "resvDayCt",
    width: 100,
  },
];
